import "../styles/esign.css";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect } from "react";
import { Button, Card, Container, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "./Langs";
import Navbar from "./Navbar";
import swal from "sweetalert";
import GetLogo from "./GetLogo";
import axios from "axios";
import { getUrl, getApiUrl } from "./urlHook";
const apiUrl = getApiUrl();

function isAlphaNumeric(str) {
  let code, i, len;

  for (i = 0, len = str.length; i < len; i++) {
    code = str.charCodeAt(i);
    if (
      !(code > 47 && code < 58) && // numeric (0-9)
      !(code > 64 && code < 91) && // upper alpha (A-Z)
      !(code > 96 && code < 123)
    ) {
      // lower alpha (a-z)
      return false;
    }
  }
  return true;
}

const Access = (props) => {
  const [openHelp, setOpenHelp] = React.useState(false);
  const [inputPassword, setInputPassword] = React.useState("");
  const [emailInput, setEmailInput] = React.useState("");
  const navigate = useNavigate();
  const logo = GetLogo();

  const submitCheck = async () => {
    const email = emailInput.toString();
    const ipwd = inputPassword.toString();

    if (email === "" || email.length === 0) {
      swal({
        title: "You must enter an email to continue",
        icon: "warning",
      });
      return false;
    }

    if (email === " " || !email.includes("@") || !email.includes(".")) {
      swal({
        title: "Must enter valid email address",
        icon: "warning",
      });
      return false;
    }

    if (ipwd === "") {
      swal({
        title: "You must enter an access code to continue",
        icon: "warning",
      });
      return;
    }

    if (!isAlphaNumeric(ipwd)) {
      swal({
        title: "Entered code contains invalid characters",
        icon: "warning",
      });
      return false;
    }

    if (ipwd.length !== 6) {
      swal({
        title: "Entered code must be 6 characters.",
        icon: "warning",
      });
      return false;
    }

    axios
      .post(`${apiUrl}/envelope`, {
        email: email.trim().toLowerCase(),
        code: ipwd.trim().toLowerCase(),
      })
      .then((res) => {
        if (res.status === 200) {
          navigate(`/document/${res.data.id}`);
        }
      })
      .catch((error) => {
        swal({
          title: "Invalid Input",
          text: "Invalid email and/or access code. Please try again.",
          icon: "error",
        });
      });

    return true;
  };

  const [lang, setLang] = useLanguage();

  useEffect(() => {
    try {
      swal.close();
    } catch (e) {
      console.log("no swals active");
    }
  }, []);

  return (
    <div style={{ backgroundColor: "#E0E0E0" }}>
      <Navbar
        lang={[lang, setLang]}
        disableToolBar
        setOpenHelp={setOpenHelp}
        openHelp={openHelp}
        color={logo.color}
        banner={logo.banner}
        helpColor={logo.helpColor}
      ></Navbar>

      <Container className="access-container mt-5">
        <Card
          className="mini-card norm-card"
          style={{
            width: "100%",
            maxWidth: "650px",
            textAlign: "center",
            margin: "0 auto",
            marginTop: "100px",
            height: "auto",
            paddingTop: "25px",
            paddingBottom: "25px",
            boxShadow: "10px 10px 5px rgba(1, 1, 1, 0.5)",
            borderColor: "transparent",
          }}
        >
          <Card.Body style={{ margin: "0 auto" }}>
            <Form role="form" data-toggle="validator" lang={lang.Current}>
              <Form.Group>
                <Form.Label
                  style={{
                    textAlign: "center",
                    fontSize: "48px",
                    wordWrap: "break-word",
                    fontFamily: "Arial, Helvetica, sans-serif",
                    fontWeight: "bold",
                  }}
                >
                  {lang.SafeSign}
                  <hr></hr>
                </Form.Label>
                <h6 style={{ marginBottom: "25px", color: "gray" }}>
                  {lang["Please enter your access code"]}
                </h6>
                <Form.Group>
                  <input
                    onKeyDown={async function checkSubmit(e) {
                      if (e && e.keyCode === 13) {
                        await submitCheck();
                      }
                    }}
                    style={{
                      marginBottom: "20px",
                    }}
                    onChange={(e) => {
                      setEmailInput(e.target.value);
                    }}
                    name="email"
                    type="email"
                    className="form-control"
                    id="emailInput"
                    minLength={1}
                    maxLength={100}
                    placeholder={lang.EnterEmail}
                    required
                  />
                  <input
                    onChange={(e) => {
                      setInputPassword(e.target.value);
                    }}
                    onKeyDown={async function checkSubmit(e) {
                      if (e && e.keyCode === 13) {
                        await submitCheck();
                      }
                    }}
                    name="accesscode"
                    type="input"
                    className="form-control"
                    id="inputPassword"
                    minLength={6}
                    maxLength={6}
                    placeholder={lang.EnterCode6}
                    required
                  />
                  <div className="help-block with-errors"></div>
                  <Button
                    id="buttonSubmit"
                    type="button"
                    variant="primary"
                    style={{
                      margin: "0 auto",
                      marginTop: "40px",
                      marginBottom: "0px",
                      width: "100%",
                      maxWidth: "200px",
                      display: "block",
                    }}
                    onClick={submitCheck}
                  >
                    {lang.ViewDocument}
                  </Button>
                </Form.Group>
              </Form.Group>
            </Form>
          </Card.Body>
        </Card>
      </Container>
      <p
        style={{
          textAlign: "center",
          margin: "50px",
          marginTop: "40px",
          paddingTop: "20px",
        }}
      >
        {lang.Experience}: <br></br>
        <a href="mailto:info@myshs.com">info@myshs.com</a>
      </p>
    </div>
  );
};
export default Access;
